import { observer } from 'mobx-react-lite';

import { CompoundButton } from 'office-ui-fabric-react/lib/Button';
import { AriaProperties, AriaRoles, generateDomPropertiesForAria } from 'owa-accessibility';
import FilePickerAction from '../../store/schema/FilePickerAction';
import * as React from 'react';

export interface FilePickerActionsPanelButtonProps {
    action: FilePickerAction;
    actionLabel: string;
    actionDescription: string;
    buttonIcon: JSX.Element;
    isDisabled: boolean;
    onActionButtonClicked: (action: FilePickerAction) => void;
    shouldAutoFocus: boolean; // Used to set the focus on first available action when the panel initially renders.
}

const styles = require('./FilePickerActionsPanelButtonView.scss');

export default observer(function FilePickerActionsPanelButtonView(
    props: FilePickerActionsPanelButtonProps
) {
    const onActionButtonClicked = () => {
        props.onActionButtonClicked(props.action);
    };
    const textButtonClassName = props.isDisabled
        ? styles.disabledActionTextButton
        : styles.actionTextButton;
    const className = props.isDisabled ? styles.disabledActionIconButton : styles.actionIconButton;
    const onClick = props.isDisabled ? () => null : () => props.onActionButtonClicked(props.action);
    const ariaProps: AriaProperties = {
        role: AriaRoles.button,
        label: `${props.actionLabel}, ${props.actionDescription}`,
    };
    return (
        <div className={styles.actionContainer}>
            <button
                className={className}
                disabled={props.isDisabled}
                onClick={onClick}
                autoFocus={props.shouldAutoFocus}
                tabIndex={
                    props.isDisabled
                        ? -1
                        : 0 /* We should be able to tab to the icon if and only if it is clickable */
                }
                {...generateDomPropertiesForAria(ariaProps)}>
                <div className={styles.iconContainer}>{props.buttonIcon}</div>
            </button>

            <CompoundButton
                className={textButtonClassName}
                description={props.actionDescription}
                disabled={props.isDisabled}
                ariaLabel={props.actionLabel}
                onClick={onActionButtonClicked}
                tabIndex={-1}>
                {props.actionLabel}
            </CompoundButton>
        </div>
    );
});
